import TotalGuestSavingsGraph from "./totalGuestSavingsGraph/totalGuestSavingsGraph.vue";
import { MyGoalService } from "@/services/myGoalsApi";
import { REQUEST_STATE, STATUS_CODE } from "@/enums";

export default {
	components: { TotalGuestSavingsGraph },

	data() {
		return {
			data: null,
			state: REQUEST_STATE.LOADING,
			REQUEST_STATE,
		};
	},

	mounted() {
		this.load();
	},

	methods: { load },
};

async function load() {
	try {
		const { data } = await MyGoalService.getTotalGuestSavings();

		this.data = data;
		this.state = REQUEST_STATE.SUCCESS;
		this.$emit(
			"loaded-data",
			data.weight_saved,
			data.last_month_weight_saved,
			data.cost_saved,
			data.last_month_cost_saved
		);
	} catch (error) {
		if (error.response && error.response.status === STATUS_CODE.MISSING_DATA) this.state = REQUEST_STATE.MISSING_DATA;
	}

	this.$emit("notifyLoaded", this.state);
}
